export const DATA_APP_ANALYSIS_DEFAULT_LIMITS = {
    investigateMaxSteps: 12,
    investigateMaxWarehouseQueries: 15,
    dailyDetectCap: 300,
    dailyInvestigateCap: 100,
    dailyPromptCap: 500,
};
/** App-author guidance is untrusted input to the model; keep it short. */
export const DATA_APP_ANALYSIS_INSTRUCTIONS_MAX_CHARS = 2000;
//# sourceMappingURL=analysis.js.map